// Packages
import { Component } from "react";
import axios from "axios";
import { Redirect, withRouter } from "react-router-dom";
import { FormGroup } from "reactstrap";
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";

// Services
import userService from "../../services/user.service";

//Utils
import { baseURL } from "../../axiosURLs";
import { getFromLocalStorage } from "../../utils/webStorage";
import { createRef } from "react";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";
import {
  planList,
  playLevelsOptions,
  schoolTypeOptions,
} from "../../utils/constant";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import CustomDropDown from "../../Common/FormFields/CustomDropDown";
import { connect } from "react-redux";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
import FormikTextField from "../../Common/FormFields/FormikInputField";
import { ContentLayoutSpinner } from "../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../Common/ContentLayoutHeader";
import Container from "@material-ui/core/Container";
import ImageUploadContainer from "../../Common/FormFields/ImageUploadContainer";
class EditSchoolDetails extends Component {
  constructor(props) {
    super(props);
    this.myref = createRef();
    this.state = {
      fields: {},
      errors: {},
      countryList: [],
      schoolTypeList: [],
      allSportsList: [],
      stateList: [],
      selectedCOuntry: "",
      countryId: null,
      stateid: "",
      firstName: "",
      lastName: "",
      address: "",
      email: "",
      phoneNumber: "",
      country: "",
      state: "",
      schoolName: "",
      schoolType: "",
      sport: "",
      status: "",
      plan: "",
      finalId: null,
      selectedFile: null,
      imagePreviewUrl: "",
      id: null,
      submitting: false,
      disabled: false,
      inputString: "",
      plans: [{ plan: "Gold" }, { plan: "Silver" }, { plan: "Bronze" }],
      isEnabled: false,
      redirectToDetailsPage: false,
      isDeleted: null,
      isLoading: false,
      schoolAdminProfileUrl: "",
      planName: "",
      statusValue: null,
      playLevel: "",
      sportName: "",
      imagePreviewUrlId: "",
      schoolAdminProfileUrlId: "",
      loading: {
        pageLoading: false,
        buttonLoading: false,
        schoolImageLoading: false,
        profileImageLoading: false,
      },
    };

    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.registerSchoolAdmin = this.registerSchoolAdmin.bind(this);
    this.handleChangestate = this.handleChangestate.bind(this);
    this.handleSubmissionForLogo = this.handleSubmissionForLogo.bind(this);
    this.changeHandlerForLogo = this.changeHandlerForLogo.bind(this);
    this.getSchoolByIdNxt = this.getSchoolByIdNxt.bind(this);
  }

  handleSubmissionForLogo = (isSchoolLogo) => {
    const { setFailPopUpInformation } = this.props;
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", this.selectedFile);
    data.append("userId", currentUserId);
    this.setState((prevState) => ({
      ...prevState,
      loading: {
        ...prevState.loading,
        [isSchoolLogo ? "schoolImageLoading" : "profileImageLoading"]: true,
      },
    }));
    userService
      .postLogoForSuperAdmin(data)
      .then((res) => {
        isSchoolLogo
          ? this.setState((prevState) => ({
              ...prevState,
              imagePreviewUrl: res.data.data.filePath,
              imagePreviewUrlId: res.data.data.id,
              loading: {
                ...prevState.loading,
                [isSchoolLogo
                  ? "schoolImageLoading"
                  : "profileImageLoading"]: false,
              },
            }))
          : this.setState((prevState) => ({
              ...prevState,
              schoolAdminProfileUrl: res.data.data.filePath,
              schoolAdminProfileUrlId: res.data.data.id,
              loading: {
                ...prevState.loading,
                [isSchoolLogo
                  ? "schoolImageLoading"
                  : "profileImageLoading"]: false,
              },
            }));
      })
      .catch(() => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  handleChangestate(e) {
    this.setState({ stateid: e.target.value });
  }
  handleCountryChange() {
    let countryId = 233;
    axios
      .post(`${baseURL}api/school/getAllStates/${countryId}`)
      .then((response) => {
        var stateList = response.data.data;
        this.setState({ stateList });
      })
      .catch((error) => {});
  }
  changeHandlerForLogo = (file, isSchoolLogo) => {
    this.selectedFile = file;
    let reader = new FileReader();

    reader.onloadend = () => {
      isSchoolLogo
        ? this.setState({
            file: file,
          })
        : this.setState({
            file: file,
          });
    };

    reader.readAsDataURL(file);
    this.handleSubmissionForLogo(isSchoolLogo);
  };
  getSchoolByIdNxt = () => {
    this.setState((prevState) => ({
      ...prevState,
      loading: {
        ...prevState.loading,
        pageLoading: true,
      },
    }));
    userService
      .getSchoolDetails(this.finalId)
      .then((response) => {
        const {
          schoolName,
          schoolType,
          firstName,
          lastName,
          country,
          state,
          plan,
          status,
          email,
          phoneNumber,
          sport,
          id,
          uploadedLogo,
          address,
          playLevel,
          user,
        } = response.data.data;
        if (!user.deleted) {
          this.myref.current.setFieldValue("schoolName", schoolName);
          this.myref.current.setFieldValue("schoolType", schoolType);
          this.myref.current.setFieldValue("firstName", firstName);
          this.myref.current.setFieldValue("lastName", lastName);
          this.myref.current.setFieldValue("country", country);
          this.myref.current.setFieldValue("state", state);
          this.myref.current.setFieldValue("plan", plan ? plan : "Gold");
          this.myref.current.setFieldValue("email", email);
          this.myref.current.setFieldValue("phoneNumber", phoneNumber);
          this.myref.current.setFieldValue("address", address);
          this.myref.current.setFieldValue("sport", sport);
          this.myref.current.setFieldValue("status", status);
          this.myref.current.setFieldValue("playLevel", playLevel);
        }
        this.state.stateid = response.data.data.state;
        this.state.inputString = response.data.data.phoneNumber;

        if (uploadedLogo != null) {
          this.setState({
            imagePreviewUrl: uploadedLogo?.filePath,
            imagePreviewUrlId: uploadedLogo?.id,
          });
        }
        if (user != null) {
          this.setState({
            schoolAdminProfileUrl: user.profileUrl?.filePath,
            schoolAdminProfileUrlId: user.profileUrl?.id,
          });
        }
        this.setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            pageLoading: false,
          },
          id,
          isDeleted: user ? user.deleted : false,
          isLoading: false,
          schoolAdminProfileUrl: user?.profileUrl?.filePath,
          planName: plan ? plan : "Gold",
          statusValue: status ? "Active" : "In-Active",
          playLevel: playLevel ? playLevel : "",
          schoolType: schoolType ? schoolType : "",
          sportName: sport ? sport : "",
          country: country ? country : "",
          state: state ? state : "",
          stateid: state,
          inputString: phoneNumber,
        }));
      })
      .catch((error) => {
        this.setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            pageLoading: false,
          },
        }));
        console.error("There was an error!", error);
      });
  };

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    this.finalId = params.schoolId;
    this.setState({ schoolId: params.schoolId });
    this.getschoolTypeList();
    this.getAllSportsList();
    this.getAllCountryList();
    this.handleCountryChange();
    this.getSchoolByIdNxt();
  }
  getAllSportsList() {
    userService
      .getAllSports()
      .then((response) => {
        const sport = response.data.data;
        this.setState({ allSportsList: [sport] });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  getschoolTypeList() {
    userService
      .getAllSchoolType()
      .then((response) => {
        var schoolTypeList = response.data.data;
        this.setState({ schoolTypeList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  getAllCountryList() {
    userService
      .getAllCountries()
      .then((response) => {
        var countryList = response.data.data;
        this.setState({ countryList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  handleCancel = () => {
    const { setConfirmationPopupInformation } = this.props;
    setConfirmationPopupInformation({
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        type: "Edit School Details",
        id: this.finalId,
      },
    });
  };

  registerSchoolAdmin({
    schoolName,
    schoolType,
    firstName,
    lastName,
    country,
    state,
    plan,
    status,
    email,
    phoneNumber,
    sport,
    playLevel,
  }) {
    const { setSuccessPopupInformation, setFailPopUpInformation } = this.props;
    const { stateid, imagePreviewUrlId, schoolAdminProfileUrlId } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      loading: {
        ...prevState.loading,
        buttonLoading: true,
      },
    }));
    userService
      .editSchoolAdmin(
        firstName,
        lastName,
        email,
        this.state.id,
        phoneNumber,
        country,
        stateid,
        status,
        imagePreviewUrlId,
        schoolAdminProfileUrlId,
        plan,
        schoolName,
        schoolType,
        sport,
        playLevel
      )
      .then((response) => {
        this.setState({ disabled: false, submitting: false });
        if (response.status === 200) {
          setSuccessPopupInformation({
            successPopUp: {
              message: "School Details Updated Successfully",
              open: true,
            },
          });
        } else {
          setFailPopUpInformation({
            open: true,
            message: "Something Went Wrong",
          });
        }
        this.setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            buttonLoading: false,
          },
        }));
      })
      .catch((error) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
        this.setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            buttonLoading: false,
          },
        }));
      });
  }
  formatPhoneNumber(phNumber) {
    let cleaned = ("" + phNumber).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
      this.myref.current.setFieldValue("phoneNumber", inputString);
    }
  }

  setPlanName = (value) => {
    this.setState({ planName: value });
  };

  statusOptions = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "In-Active",
      value: false,
    },
  ];

  updateState = (name, value) => {
    this.setState({ [name]: value });
  };

  render(props) {
    const {
      submitting,
      disabled,
      schoolId,
      imagePreviewUrl,
      errors,
      countryList,
      stateList,
      allSportsList,
      id,
      redirectToDetailsPage,
      isDeleted,
      isLoading,
      schoolAdminProfileUrl,
      planName,
      statusValue,
      playLevel,
      schoolType,
      sportName,
      country,
      state,
      loading,
    } = this.state;

    if (redirectToDetailsPage) {
      return <Redirect to={`/schoolnamescreen/${id}`} />;
    }

    return (
      <div>
        {!isDeleted && (
          <div>
            <Formik
              innerRef={this.myref}
              initialValues={{
                schoolName: "",
                schoolType: "",
                firstName: "",
                lastName: "",
                country: "",
                state: "",
                email: "",
                phoneNumber: "",
                sport: "",
                playLevel: "",
                plan: "",
                status: "",
              }}
              validationSchema={validationSchema.editSchoolProfileValidation}
              onSubmit={(values) => this.registerSchoolAdmin(values)}
            >
              {(formik) => (
                <Form>
                  <div className="content-layout pt-20 add-sectionn position-relative">
                    <SuperAdminDashboard />
                    <ContentLayoutSpinner animate={loading?.pageLoading} />
                    <ContentLayoutHeader
                      heading="Edit School"
                      handleCancel={this.handleCancel}
                      navigationLink={`/schoolnamescreen/${schoolId}`}
                      btnText="Update"
                      loading={loading?.buttonLoading}
                      disabled={!formik.isValid}
                    />
                    <Container className="mg-bottom-20">
                      <div name="adminRegistrationForm">
                        <div className="col-12 col-md-9 col-lg-5">
                          <div className="white-card">
                            <ImageUploadContainer
                              id="upload-photo-1"
                              logoUrl={imagePreviewUrl}
                              handleUpload={(file) =>
                                this.changeHandlerForLogo(file, true)
                              }
                              label={
                                imagePreviewUrl
                                  ? "Update School Logo"
                                  : "Add School Logo"
                              }
                              loading={loading?.schoolImageLoading}
                            />
                          </div>
                          <div className="clear20"></div>
                          <div className="white-card">
                            <ImageUploadContainer
                              id="upload-photo-2"
                              logoUrl={schoolAdminProfileUrl}
                              handleUpload={(file) =>
                                this.changeHandlerForLogo(file, false)
                              }
                              label={
                                schoolAdminProfileUrl
                                  ? "Update Profile Photo"
                                  : "Add Profile Photo"
                              }
                              loading={loading?.profileImageLoading}
                            />
                          </div>
                          <div className="clear20"></div>
                          <div className="white-card">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormikTextField
                                  label="FirstName"
                                  formik={formik}
                                  fieldName="firstName"
                                  placeholder="Enter First name"
                                  labelFontSize="fs-18"
                                />
                                <div className="clear10"></div>
                                <FormikTextField
                                  label="LastName"
                                  formik={formik}
                                  fieldName="lastName"
                                  placeholder="Enter Last name"
                                  labelFontSize="fs-18"
                                />
                                <div className="clear10"></div>
                                <FormikTextField
                                  label="Email"
                                  formik={formik}
                                  fieldName="email"
                                  placeholder="Enter Email Address"
                                  labelFontSize="fs-18"
                                  isDisabled={true}
                                />
                                <div className="clear10"></div>
                                <div className="row">
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <FormGroup>
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Phone Number
                                        <span className="redstar">*</span>
                                      </label>
                                      <Field
                                        className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect ${
                                          formik.errors.phoneNumber &&
                                          formik.touched.phoneNumber &&
                                          "is-invalid"
                                        }`}
                                        name="phoneNumber"
                                        placeholder="Enter Phone Number"
                                        maxLength="10"
                                        onKeyUp={(e) =>
                                          this.formatPhoneNumber(e.target.value)
                                        }
                                      />
                                      <div className="errorMsg fs-14 medium">
                                        {formik.errors.phoneNumber}
                                      </div>
                                    </FormGroup>
                                  </div>
                                </div>
                                <div className="clear10"></div>
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold fs-18">
                                    Select Country{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <CustomDropDown
                                    selected={country}
                                    setSelected={(value) =>
                                      this.updateState("country", value)
                                    }
                                    formik={formik}
                                    fieldName="country"
                                    defaultSelectOption="Select Country"
                                    options={countryList}
                                    fieldToShow="name"
                                    optionValue="name"
                                    isDisabled="disabled"
                                  />
                                </FormGroup>
                                <div className="clear10"></div>
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold fs-18">
                                    Select State{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <CustomDropDown
                                    selected={state}
                                    setSelected={(value) =>
                                      this.updateState("state", value)
                                    }
                                    formik={formik}
                                    fieldName="state"
                                    defaultSelectOption="Select State"
                                    options={stateList}
                                    fieldToShow="name"
                                    optionValue="name"
                                    isDisabled="disabled"
                                  />
                                </FormGroup>
                                <div className="clear10"></div>
                                <FormikTextField
                                  label="School Name"
                                  formik={formik}
                                  fieldName="schoolName"
                                  placeholder="Enter School Name"
                                  labelFontSize="fs-18"
                                />
                                <div className="clear10"></div>
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold fs-18">
                                    Select School Type{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <CustomDropDown
                                    selected={schoolType}
                                    setSelected={(value) =>
                                      this.updateState("schoolType", value)
                                    }
                                    formik={formik}
                                    fieldName="schoolType"
                                    defaultSelectOption="Select School Type"
                                    options={schoolTypeOptions}
                                    fieldToShow="name"
                                    optionValue="name"
                                    isDisabled="disabled"
                                  />
                                </FormGroup>
                                <div className="clear10"></div>
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold fs-18">
                                    Select Sport{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <CustomDropDown
                                    selected={sportName}
                                    setSelected={(value) =>
                                      this.updateState("sportName", value)
                                    }
                                    formik={formik}
                                    fieldName="sport"
                                    defaultSelectOption="Select Sport"
                                    options={allSportsList}
                                    fieldToShow="sportName"
                                    optionValue="sportName"
                                    isDisabled="disabled"
                                  />
                                </FormGroup>
                                <div className="clear10"></div>
                                <div className="row">
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <FormGroup>
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Select Play Level{" "}
                                        <span className="redstar">*</span>
                                      </label>
                                      <CustomDropDown
                                        selected={playLevel}
                                        setSelected={(value) =>
                                          this.updateState("playLevel", value)
                                        }
                                        formik={formik}
                                        fieldName="playLevel"
                                        defaultSelectOption="Select Play Level"
                                        options={playLevelsOptions}
                                        fieldToShow="name"
                                        optionValue="name"
                                        isDisabled="disabled"
                                      />
                                    </FormGroup>
                                    <div className="clear10"></div>
                                    <FormGroup>
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Select Plan{" "}
                                        <span className="redstar">*</span>
                                      </label>
                                      <CustomDropDown
                                        selected={planName}
                                        setSelected={(value) =>
                                          this.updateState("planName", value)
                                        }
                                        formik={formik}
                                        fieldName="plan"
                                        defaultSelectOption="Select Plan"
                                        options={planList}
                                        fieldToShow="planName"
                                        optionValue="planName"
                                        isDisabled="disabled"
                                      />
                                    </FormGroup>
                                    <div className="clear10"></div>
                                    <FormGroup>
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Select Status{" "}
                                        <span className="redstar">*</span>
                                      </label>
                                      <CustomDropDown
                                        selected={statusValue}
                                        setSelected={(value) =>
                                          this.updateState("statusValue", value)
                                        }
                                        formik={formik}
                                        fieldName="status"
                                        defaultSelectOption="Select Status"
                                        options={this.statusOptions}
                                        fieldToShow="name"
                                        optionValue="value"
                                        isDisabled="disabled"
                                      />
                                    </FormGroup>
                                    <div className="clear10"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Container>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
        {isDeleted && !isLoading && <PageNotFoundPage />}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditSchoolDetails)
);
